import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import 'css!bundles/page/components/__styles__/MobileBreadCrumb';

const MobileBreadCrumb = ({ href, label, styles }: $TSFixMe) => {
  if (!label || !href) {
    return null;
  }

  const wrapperClasses = classNames('rc-mobileBreadcrumb', 'breadcrumbs-list');

  return (
    <div className={wrapperClasses} style={{ ...styles }}>
      <TrackedLink2 className={classNames('mobile-breadcrumb-link')} href={href} trackingName="mobile_breadcrumb_link">
        <span className="breadcrumb-item-divider" aria-hidden="true">
          &#60;
        </span>
        <span className="breadcrumb-item">{label}</span>
      </TrackedLink2>
    </div>
  );
};

MobileBreadCrumb.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  styles: PropTypes.object,
};

export default MobileBreadCrumb;
